// Mock data for demo requests and contact forms
export const mockDemoRequests = [];
export const mockContactSubmissions = [];

// Mock form submission functions
export const submitDemoRequest = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const submission = {
        id: Date.now(),
        ...formData,
        timestamp: new Date().toISOString(),
        status: 'pending'
      };
      mockDemoRequests.push(submission);
      console.log('Demo request submitted:', submission);
      resolve({ success: true, message: 'Demo request submitted successfully!' });
    }, 1000);
  });
};

export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const submission = {
        id: Date.now(),
        ...formData,
        timestamp: new Date().toISOString(),
        status: 'pending'
      };
      mockContactSubmissions.push(submission);
      console.log('Contact form submitted:', submission);
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};

// Mock data getter functions
export const getDemoRequests = () => mockDemoRequests;
export const getContactSubmissions = () => mockContactSubmissions;